import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { useString } from '../settings/settings.strings.js';
import { Root, Range, Point, Thumb } from '../slider-primitive/slider-primitive.js';
import { range, dot, mainDot, thumb, thumbShadow, thumbBg, root, size } from './slider.css.js';

/**
 * Used for adjusting between a range with a min and a max value.
 * @see https://fpl.figma.design/components/slider/
 */
const Slider = forwardRef(({ style, size: size$1 = 'md', rangeAnchor, mixed, valueText, ...props }, ref) => {
    // If `defaultValue` isn't provided then we should always consider this modified
    const modified = props.value !== props.defaultValue;
    const mixedLabel = useString('mixed');
    return (jsxs(Root, { "data-fpl-component": "", ...props, ref: ref, className: clsx(root, size[size$1]), style: style, valueText: valueText ?? (mixed ? mixedLabel : undefined), "data-mixed": mixed || undefined, "data-modified": modified || undefined, children: [rangeAnchor != null && (jsx(Range, { className: range, start: rangeAnchor, end: props.value })), props.hints?.map((hint, i) => (jsx(Point, { className: clsx(dot, { [mainDot]: hint === props.defaultValue }), value: hint }, i))), jsxs(Thumb, { className: thumb, children: [jsx("div", { className: thumbShadow }), jsx("div", { className: thumbBg })] })] }));
});
Slider.displayName = 'Slider';

export { Slider };
//# sourceMappingURL=slider.js.map
